export const MAX_NUMBER_OF_MEMBERS = 50;
